// src/components/Header.jsx
import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="dashboard-header">
      <div className="header-container">
        <div className="left-block">
          <h1 className="header-title">🤖 Vortrex AI Dashboard</h1>
          <p className="header-subtext">Track bot activity, profits, and wallet overview</p>
        </div>
        <div className="right-block">
          <div className="wallet-pill">
            🪙 <span>0x23eE...d9e</span>
          </div>
          <div className="status-pill">
            ✅ Bot Status: <strong>Active</strong>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
